import { roleNames } from "../constant";

export const redirectToDashboard = (role, navigate) => {
  switch (role) {
    case roleNames.superAdmin:
      navigate("/admin-dashboard");
      break;
    case roleNames.qa:
      navigate("/qa-dashboard");
      break;
    default:
      navigate("/login");
  }
};
